var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTailormedVisualIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 20,
    viewBox: "0 0 25 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.91113 10.5325C3.36775 9.60717 6.45288 8.23226 10.3246 9.83035C15.764 12.0754 20.125 12.1743 24.015 7.87213",
    stroke: "#101828"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.91113 17.3305V3.14299V17.3305Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.91113 17.3305V3.14299",
    stroke: "#101828",
    strokeWidth: 0.752475
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.66211 17.3305C9.66211 17.0434 9.66211 15.7535 9.66211 13.4607C9.66211 11.1678 9.66211 7.72861 9.66211 3.14297",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.66211 17.3305C9.66211 17.0434 9.66211 15.7535 9.66211 13.4607C9.66211 11.1678 9.66211 7.72861 9.66211 3.14297",
    stroke: "#101828",
    strokeWidth: 0.752475
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.823 2.14736C2.823 2.69711 2.41485 3.14298 1.91161 3.14298C1.40815 3.14298 1 2.69711 1 2.14736C1 1.59738 1.40815 1.15175 1.91161 1.15175C2.41485 1.15175 2.823 1.59738 2.823 2.14736Z",
    fill: "white",
    stroke: "#101828",
    strokeWidth: 0.752475
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.572 18.3261C10.572 18.8761 10.1639 19.3217 9.66062 19.3217C9.15717 19.3217 8.74902 18.8761 8.74902 18.3261C8.74902 17.7761 9.15717 17.3305 9.66062 17.3305C10.1639 17.3305 10.572 17.7761 10.572 18.3261Z",
    fill: "white",
    stroke: "#101828",
    strokeWidth: 0.752475
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.4062 17.3305V3.14296V17.3305Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4062 17.3305V3.14296",
    stroke: "#101828",
    strokeWidth: 0.752475
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.322 2.14736C18.322 2.69711 17.914 3.14298 17.4105 3.14298C16.907 3.14298 16.499 2.69711 16.499 2.14736C16.499 1.59738 16.907 1.15175 17.4105 1.15175C17.914 1.15175 18.322 1.59738 18.322 2.14736Z",
    fill: "white",
    stroke: "#101828",
    strokeWidth: 0.752475
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTailormedVisualIcon);
export default __webpack_public_path__ + "static/media/TailormedVisualIcon.529ce0ba13e41639a77ba2faee714df5.svg";
export { ForwardRef as ReactComponent };